import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  /** What exactly is about to be removed, and any knock-on effect. */
  description: React.ReactNode;
  /** Confirm button text — name the thing, e.g. "Delete work order". */
  confirmLabel: string;
  isPending: boolean;
  onConfirm: () => void;
}

/**
 * Destructive-action confirmation used by the Property Management tabs. Deletes
 * here are permanent (no soft-delete column), so every one is gated behind this
 * modal. The confirm button stays mounted while the mutation runs so the dialog
 * can show pending state instead of closing optimistically.
 */
export function DeleteConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel,
  isPending,
  onConfirm,
}: Props) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            disabled={isPending}
            onClick={(e) => {
              // Keep the dialog open until the mutation resolves — the caller
              // closes it in its onSuccess.
              e.preventDefault();
              onConfirm();
            }}
          >
            {isPending ? "Deleting…" : confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
